export default __webpack_public_path__ + "static/media/GettingStarted.1d3de443.md";